import React from 'react'
import "./SubStyle.css"

const Care_Sale = () => {
  return (
    <>
      <main className="care-sales-hero">

      

        {/* LEFT CONTENT */}
        <div className="care-sales-content">

          <span className="sales-tag">
            EXPERTS IN CARE HOME SALES
          </span>

          <h1>Care homes for sale. <span>Trusted deals.</span>Better outcomes.</h1>

          <p>
            We help care home owners buy, sell and value care homes
            with confidence. From confidential marketing to due
            diligence and negotiation – we manage the process, so
            you get the right result.
          </p>

          {/* BUTTONS */}
          <div className="sales-buttons">

            <button className="primary-sales-btn">
              View Available Homes
            </button>

            <button className="secondary-sales-btn">
              Book a Free Consultation
            </button>

          </div>

          {/* FEATURES */}
          <div className="sales-features">

            <span>
              <b>✓</b> Confidential & Secure
            </span>

            <span>
              <b>✓</b> Expert Valuation
            </span>

            <span>
              <b>✓</b> End-to-End Support
            </span>

          </div>

        </div>

        {/* ================= DASHBOARD ================= */}
        <div className="sales-dashboard">

          <div className="dashboard-header">
            <h3>Care Home Sales Overview</h3>

            <span>
              This Month <small>⌄</small>
            </span>
          </div>

          {/* TOP CARDS */}
          <div className="dashboard-stats">

            <div className="stat-card">
              <div className="stat-icon">▣</div>
              <small>Homes For Sale</small>
              <strong>28</strong>
              <span>Active Listings</span>
            </div>

            <div className="stat-card">
              <div className="stat-icon">♙</div>
              <small>New Listings</small>
              <strong>6</strong>
              <span>This Month</span>
            </div>

            <div className="stat-card">
              <div className="stat-icon">♙</div>
              <small>Under Offer</small>
              <strong>7</strong>
              <span>In Progress</span>
            </div>

            <div className="stat-card">
              <div className="stat-icon">⌁</div>
              <small>Sold</small>
              <strong>12</strong>
              <span>This Month</span>
            </div>

            <div className="stat-card">
              <div className="stat-icon">£</div>
              <small>Avg. Sale</small>
              <strong>£1.42M</strong>
              <span>12% vs last month</span>
            </div>

          </div>

          {/* CHART AREA */}
          <div className="dashboard-charts">

            {/* REGION */}
            <div className="chart-box">
              <h4>Properties by Region</h4>

              <div className="donut-wrapper">

                <div className="donut-chart">
                  <div className="donut-inner"></div>
                </div>

                <div className="chart-labels">
                  <span>● South East <b>40%</b></span>
                  <span>● North West <b>20%</b></span>
                  <span>● West Midlands <b>15%</b></span>
                  <span>● Yorkshire <b>15%</b></span>
                  <span>● Others <b>10%</b></span>
                </div>

              </div>
            </div>

            {/* PRICE */}
            <div className="chart-box">
              <h4>Asking Price Range</h4>

              <div className="bar-chart">

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "35%" }}
                  ></div>
                  <span>&lt; £500K</span>
                </div>

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "55%" }}
                  ></div>
                  <span>£500K–£1M</span>
                </div>

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "85%" }}
                  ></div>
                  <span>£1M–£2M</span>
                </div>

                <div className="bar-item">
                  <div
                    className="bar"
                    style={{ height: "58%" }}
                  ></div>
                  <span>£2M+</span>
                </div>

              </div>
            </div>

            {/* PIPELINE */}
            <div className="chart-box">
              <h4>Sale Pipeline</h4>

              <div className="pipeline">

                <div className="pipeline-donut">
                  <strong>14</strong>
                  <span>Total</span>
                </div>

                <div className="pipeline-labels">
                  <span>● Initial Enquiry <b>5</b></span>
                  <span>● Valuation <b>4</b></span>
                  <span>● Due Diligence <b>3</b></span>
                  <span>● Negotiation <b>2</b></span>
                </div>

              </div>
            </div>

          </div>

          {/* RECENT LISTINGS */}
          <div className="recent-listings">

            <h4>Recent Listings</h4>

            <div className="listing-table">

              <div className="table-row table-heading">
                <span>Property Name</span>
                <span>Location</span>
                <span>Type</span>
                <span>Beds</span>
                <span>Asking Price</span>
                <span>Status</span>
              </div>

              <div className="table-row">
                <span>Greenfield Care Home</span>
                <span>Surrey</span>
                <span>Residential</span>
                <span>45</span>
                <span>£1,850,000</span>
                <span className="status green">
                  For Sale
                </span>
              </div>

              <div className="table-row">
                <span>Meadow View Care Home</span>
                <span>Manchester</span>
                <span>Nursing</span>
                <span>38</span>
                <span>£1,250,000</span>
                <span className="status orange">
                  Under Offer
                </span>
              </div>

              <div className="table-row">
                <span>Riverside Care Home</span>
                <span>Birmingham</span>
                <span>Residential</span>
                <span>30</span>
                <span>£950,000</span>
                <span className="status green">
                  For Sale
                </span>
              </div>

              <div className="table-row">
                <span>Woodlands Care Home</span>
                <span>Leeds</span>
                <span>Nursing</span>
                <span>42</span>
                <span>£1,650,000</span>
                <span className="status blue">
                  Due Diligence
                </span>
              </div>

            </div>
          </div>

        </div>
      </main>

      {/* SCROLL DOWN */}
      <div className="scroll-down">
        <div className="mouse-icon">
          <span></span>
        </div>
        <p>Comming Soon</p>
      </div>
      </>
  )
}

export default Care_Sale
